/* =========================================================
   src/values.jsx
   ========================================================= */

const VALUES = [
  {
    n: "i.",
    title: "Reliability",
    body: "We do what we say, deliver what we promise, and answer the phone when things get complicated. Rare enough these days.",
  },
  {
    n: "ii.",
    title: "Responsibility",
    body: "Deadlines matter. Budgets matter. Security matters. We treat your business like it has consequences - because it does.",
  },
  {
    n: "iii.",
    title: "Human Approach",
    body: "Behind every system, process, and dashboard are actual people trying to get work done. We never forget that.",
  },
  {
    n: "iv.",
    title: "Professionalism",
    body: "Sharp thinking, clean execution, no chaos behind the curtain. Just experienced people doing serious work properly.",
  },
  {
    n: "v.",
    title: "Innovation",
    body: "Not innovation for slides and buzzwords - innovation that saves time, removes friction, and gives you an unfair advantage.",
  },
];

function Values() {
  return (
    <section id="values" className="band-dark">
      <div className="wrap">
        <div className="sec-head">
          <div className="reveal-up">
            <div className="sec-tag">Values</div>
            <h2 className="sec-title">How we <em>show up.</em></h2>
          </div>
          <div className="sec-aside reveal-up delay-1">
            The five principles that shape how our team works - with each other and with you.
          </div>
        </div>
        <div className="values-list">
          {VALUES.map((v, i) => (
            <div className={"value reveal-up delay-" + (i % 5)} key={v.title} data-hover>
              <div className="value-num">{v.n}</div>
              <h3 className="value-title">{v.title}</h3>
              <p className="value-body">{v.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

Object.assign(window, { Values });
